<template>
  <div v-if="formData" class="contract-information-page" v-loading.fullscreen.lock="fullscreenLoading">
    <Title currentPageTitle="申请市场拓展规划方案"></Title>
    <!-- 申请信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name">申请信息</p>
      <div class="contract-apply-box">
        <div class="contract-apply-item"><span>申请人：</span>{{ formData.applyStaffName }}</div>
        <div class="contract-apply-item"><span>提交时间：</span>{{ formData.submitTime | getDate}}</div>
        <div class="contract-apply-item"><span>所在部门：</span>{{ formData.approveVO.organisationName}}</div>
      </div>
      <!-- 附件 -->

      <img
        v-show="formData.approveState && formData.approveState !== 'N'"
        class="approve-img"
        :src="getApproveImg()"
        alt=""
      />
    </div>
    <!-- 详细信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name">详细信息</p>
      <el-row :gutter="24">
        <el-col :span="12">
          <span class="contract-base-title">公司名称：</span>
          <div class="contract-base-content">{{ formData.tenantName }}</div>
        </el-col>

        <el-col :span="12">
          <span class="contract-base-title">报告名称：</span>
          <div class="contract-base-content">{{ formData.reportName }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="24">

        <el-col :span="12">
          <span class="contract-base-title">分析行业：</span>
          <div class="contract-base-content">
              <span class="label">{{ getName(formData.categoryGuid, '药械分类') }}</span>
              <span class="label">{{ getNameNew(formData.useGuid, getCodeListByKeyPage(formData.categoryGuid == 3 ? '医疗器械管理分类' : '药品功能和用途分类')) }}</span>
              <span class="label">{{ getNameNew(formData.propertyGuid, getCodeListByKeyPage(formData.categoryGuid == 3 ? '医疗器械68分类' : '药品性质分类')) }}</span>
          </div>
        </el-col>

        <el-col :span="12">
          <span class="contract-base-title">分析产品：</span>
          <div class="contract-base-content">{{formData.goodsName  }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <span class="contract-base-title">分析年限：</span>
          <div class="contract-base-content">{{ getName(formData.yearLimit,'分析年限') }}</div>
        </el-col>

        <el-col :span="12">
          <span class="contract-base-title">推广月份：</span>
          <div class="contract-base-content">{{ formData.expandMonth || '-'}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <span class="contract-base-title">市场范围：</span>
          <div class="contract-base-content">{{ formData.marketRangJson[0][0]=='000000'?'全国':getArea(formData.marketRangJson) }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">分析目的：</span>
          <div class="contract-base-content">{{  getName(formData.purposeGuid,'分析目的')}}</div>
        </el-col>
      </el-row>
        

    </div>

    <div class="contract-base-box">
      <p class="contract-base-name" style="margin-bottom: 6px;">方案附件</p>
      <div class="contract-base-box">
        <div class="contract-apply-file">
          <!-- <span>方案附件：</span> -->
          <div>
            <div v-for="(item, index) in formData.attach" :key="index">
              <div class="contract-file-inform">
                <img
                  width="32"
                  height="32"
                  class="mr10"
                  :src="item.path.indexOf('pdf')>-1?require('../../assets/images/pdf_icon.png'): require('../../assets/images/word_icon.png')"
                /><span> {{ item.fileName }}</span>
                <span  class="fontC-4fa1a4 c-pointer ml10" @click="toSee(item,2)">预览</span>
                <span class="fontC-4fa1a4 c-pointer ml10" @click="toSee(item,1)">下载</span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- 流程 -->
    <div style="padding-left: 16px; background: #fff; margin-top: 4px">
      <iframe v-show="iframeSh" :src="srcs" class="iframe-sty"></iframe>
    </div>
    <!-- 提交 -->
    <div class="submit-btn-box submit_btn_wrap" v-if="formData">
      <el-button type="borderBlack" size="small" @click="$router.go(-1)">取消</el-button>
      <el-button type="borderRed" size="small" v-show="getBtnState('approval') == 'approval'" @click="toReject"
        >驳回</el-button
      >
      <el-button type="importNew" size="small" v-show="getBtnState('approval') == 'approval'" @click="toPass"
        >通过</el-button
      >
      <el-button type="importNew" size="small" v-show="getBtnState('again') == 'again'&& formData.approveState != 'D'"" @click="reSubmit"
        >重新提交</el-button
      >
      <el-button type="importNew" size="small" v-show="getBtnState('revoke') == 'revoke'" @click="toRevoke"
        >撤销</el-button
      >
    </div>
    <el-dialog title="驳回流程" :visible.sync="rejectDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest" maxlength="100"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    <el-dialog title="通过流程" :visible.sync="passDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入通过备注（非必填）" v-model="approveSuggest" maxlength="100"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { bpmnroute } from '@/api/apiRoute';
import Title from '@/components/title/title.vue';
import workFlowCommon from '@/uilt/workFlowCommon';
import areaJson from '../../assets/js/china_address_v4.js';
export default {
  components: {
    Title,
  },
  data() {
    return {
      fullscreenLoading:false,
      options:areaJson,
      flowType: '00027',
      rejectDialogVisible: false,
      passDialogVisible: false,
      approveSuggest: '',
      formData: null,
      fileList: [],
      ccFileList:[],
      contractFileName: '',
      //流程
      srcs: '',
      processInstanceId: '',
      iframeSh: true,
      currentStaffGuid: null, //当前登录人guid
      goodsCodeList:[],
    };
  },
    created() {
        let userinfo = JSON.parse(localStorage.userInfo);
        this.currentStaffGuid = userinfo.staffGuid;
        this.getPageDetail();
        this.getBpmnUrl();
        this.getGoodsCode();
    },
    methods: {
        getArea(marketRangJson) {
            let list = [];
            let result = [];
            marketRangJson.forEach(m => {
                let distance = [];
                this.options.forEach(n => {
                    if (m[0] == n.value) {
                      distance.push(n.label)
                      if (m[1]) {
                          n.children.forEach(j => {
                              if (m[1] == j.value) {
                              distance.push(j.label)
                                  if (m[2]) {
                                      j.children.forEach(k => {
                                          if (m[2] == k.value) {
                                          distance.push(k.label)
                                          }
                                      })
                                  }
                              }
                          })
                      }
                      list.push(distance)
                    }
              
                })
            })
            list.forEach(item=>{
              result.push(item.join('/'))
            })
            console.log(result)
            return result.join('、');
        },
        getGoodsCode() {
            let self = this;
            self.api.get(
                `/${serverConfig.msConfigureService}/dict/get-tree-by-dictType?dictType=商品大类字典`
            ).then((res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    this.goodsCodeList = res.data.data;
                    console.log('goodsCodeList');
                    
                } else {
                    self.$message.error(res.msg || '服务异常');
                    console.log(res);
                    self.loading = false;
                }
            });
        },
        getCodeListByKeyPage(key) {
          
            let list = this.goodsCodeList.filter(item => item.dicName == key)
            console.log('this.goodsCodeList',this.goodsCodeList,list);
            return list.length ? list[0].childList : [];
        },
        getName(name, key) {
            if (!name) return '-';
            let list = this.getCodeListByKey(key);
            if (typeof name == 'object') {
                let newArr = [];
                name.forEach(item => {
                    list.forEach(el => {
                        if (el.value == item) {
                            newArr.push(el.text);
                        }
                    })
                })
                return newArr.length ? newArr.join('、') : '-';
            } else {
                let lisArr = list.filter(item => item.value == name);
                return lisArr.length ? lisArr[0].text : '-';
            }

        },
        getNameNew(value, list) {
            let item = list.filter(item => item.dicValue == value)||[]
            console.log('list',list,item);
            return item.length>0? item[0].dicName:'-'
        },
        //状态图片
        getApproveImg() {
            return workFlowCommon.getApproveImg(this.formData.approveVO.approveState);
        },
        //查看附件
        toSee(item, type) {
            let url = item.path;
            if (type == 1) {
              window.open(url + '?response-content-type=application/octet-stream');
            } else {
              if (url.indexOf('.pdf' || '.PDF') > -1) {
                window.open(url);
              } else {
                window.open('https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(url));
              }
            }
        },
        getBtnState(btnType) {
          let approveVO = this.formData.approveVO;
          return workFlowCommon.getListBtnState(
              btnType,
              approveVO.approveState,
              approveVO.staffGuid,
              approveVO.approveStaffGuids,
              this.currentStaffGuid,
              approveVO.approveState,
          );
       },
        //获取详情
        getPageDetail() {
          this.fullscreenLoading = true;
            this.api.get(`/${serverConfig.msSalesPerformService}/market-expand-plan/detail/${this.$route.query.guid}`).then((res) => {
              this.fullscreenLoading = false;
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    let data = res.data.data;
                    this.formData = data;
                    this.formData.goodsName = this.getGoodsName(data.goods);
                } else {
                    this.$message.error(msg);
                }
            });
        },
        getGoodsName(res) {
            var list = [];
            if (!res) return '';
            if (res.length >= 2) {
                res.forEach((item, index) => {
                    if (index <= 1) {
                        list.push(item.goodsName);
                    }
                });
                return list.join("、") + "等" + res.length + "个产品";
            } else {
                return res[0].goodsName;
            }
        },
        getBpmnUrl() {
            if (this.$route.query.camundaInstanceId && this.$route.query.camundaDeploymentId) {
                this.srcs =
                    bpmnroute +
                    '/iframeBpmn?processInstanceId=' +
                    this.$route.query.camundaInstanceId +
                    '&camundaDeploymentId=' +
                    this.$route.query.camundaDeploymentId +
                    '&token=' +
                    localStorage.token;
                console.log(this.srcs)
            } else {
                this.iframeSh = false;
            }
        },
        //撤销
        toRevoke() {
            let self = this;
            let approveVO = this.formData.approveVO;
            self
                .$confirm('确定撤销吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                })
                .then(() => {
                    let query = {
                        guid: approveVO.approveGuid,
                        flowType: self.flowType,
                        approveStaffGuid: self.currentStaffGuid,
                    };
                    self.fullscreenLoading = true;
                    self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query).then((res) => {
                        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                            self.fullscreenLoading = false;
                            self.$message.success(messageConfig.FLOW_CANCEL);
                            sessionStorage.refresh = 1;
                            self.$router.go(-1);
                        } else {
                            self.$message.error(res.data.msg);
                        }
                    });
                })
                .catch(() => {
                    self.$message({
                        type: 'info',
                        message: '已取消操作！',
                    });
                });
        },
        //重新提交
        reSubmit() {
            this.$router.push({
              path:'marketTzEdit',
              query: {
                guid: this.formData.guid,
                type: 2,
                camundaInstanceId: this.formData.approveVO.camundaInstanceId,
                camundaDeploymentId: this.formData.approveVO.camundaDeploymentId
              }
            });
        },
        toPass() {
            let self = this;
            self.approveSuggest = '';
            self.passDialogVisible = true;
        },
        toReject() {
            let self = this;
            self.approveSuggest = '';
            self.rejectDialogVisible = true;
        },
        //通过
        toPassSubmit() {
            let self = this;
            let approveVO = this.formData.approveVO;
            let query = {
                guid: approveVO.approveGuid,
                flowType: self.flowType,
                approveSuggest: self.approveSuggest,
                approveStaffGuid: self.currentStaffGuid,
            };
            self.fullscreenLoading = true;
            self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
                self.fullscreenLoading = false;
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    self.$message.success(messageConfig.FLOW_PASS);
                    sessionStorage.refresh = 1;
                    self.$router.go(-1);
                } else {
                    self.$message.error(res.data.msg);
                }
            });
        },
        //驳回
        toRejectSubmit() {
            let self = this;
            let approveVO = this.formData.approveVO;
            if (self.approveSuggest == '') {
                self.$message.error('请填写驳回理由！');
                return;
            }
            let query = {
                guid: approveVO.approveGuid,
                flowType: self.flowType,
                approveSuggest: self.approveSuggest,
                approveStaffGuid: self.currentStaffGuid,
            };
            self.fullscreenLoading = true;
            self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
                self.fullscreenLoading = false;
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    self.$message.success(messageConfig.FLOW_REJECT);
                    sessionStorage.refresh = 1;
                    self.rejectDialogVisible = false;
                    self.$router.go(-1);
                } else {
                    self.$message.error(res.data.msg);
                }
            });
        },
    },
};
</script>
<style scoped>
.contract-information-page {
  overflow: auto;
}
.contract-base-box {
  position: relative;
  padding: 10px 16px;
  margin-top: 4px;
  background: #fff;
}
.contract-base-name {
  font-size: 16px;
  color: #212121;
  text-align: left;
  margin: 8px 0 20px 0;
}
/* 申请信息 */
.contract-apply-box {
  display: flex;
  padding-left: 10px;
  margin-bottom: 25px;
}
.contract-apply-item {
  font-size: 14px;
  color: #666666;
  padding: 0 20px;
  box-sizing: border-box;
  border-right: 1px solid #e5e5e5;
}
.contract-apply-file {
  display: flex;
  font-size: 14px;
  color: #666666;
  padding: 0 16px;
  box-sizing: border-box;
  line-height: 32px;
}
.contract-file-inform {
  display: flex;
  align-items: center;
  /* margin-bottom: 23px; */
}
.approve-img {
  position: absolute;
  top: 50%;
  right: 60px;
  width: 78px;
  height: 78px;
  margin-top: -39px;
}
/* 合同信息 */
.contract-base-box .el-col-12 ,.contract-base-box .el-col-24{
  display: flex;
  line-height: 22px;
  margin-bottom: 20px;
}
.el-col-12:nth-child(2n + 1) .contract-base-title ,.el-col-24:nth-child(2n + 1) .contract-base-title{
  flex-shrink: 0;
  width: 100px;
  text-align: right;
  font-size: 14px;
  color: #666666;
}
.el-col-12:nth-child(2n) .contract-base-title ,.el-col-12:nth-child(2n) .contract-base-title{
  flex-shrink: 0;
  width: 140px;
  text-align: right;
  font-size: 14px;
  color: #666666;
}
.contract-base-content {
  color: #212121;
  text-align: left;
}
/* 流程 */
.iframe-sty {
  width: 100%;
  height: 500px;
  border: none;
  /* background:grey; */
}
.submit-btn-box {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  border-top: 1px solid #d9d9d9;
  background: #fff;
}
.contract-base-content .label{
  color:#276FF5 ;
  border: 1px solid #276FF5;
  display: inline-block;
  padding: 0 2px;
  border-radius: 4px;
  margin-right: 4px;
}
</style>
